import { connect } from "react-redux";
import { Link } from "react-router-dom";

var ArbitrarySubjects = require("lib/data/ArbitrarySubjects");
var TextTypes = require("lib/academic/TextTypes");
var GradeLevel = require("lib/academic/GradeLevel");

var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var ReadingActions = require("lib/actions/ReadingActions");
var ReadingLevelFormat = require("lib/academic/ReadingLevelFormat");

var Spinner = require("components/utility/Spinner");
var CurrentUser = require("lib/account/CurrentUser");
var ReadingLevelIcon = require("components/reading/reading_levels/ReadingLevelIcon");
var Glyphicon = require("components/utility/icons/Glyphicon");

require("reading/books/book_display.scss");

@connect(
	(state, props) => {
		var book = ReadingSelectors.book({ state, id: props.textID });

		if (book && book.platform_id) {
			var platform = ReadingSelectors.platform({ state, id: book.platform_id });
		}
		return {
			book, platform,
			readingLevelFormat: CurrentUser.get().prefs.reading_level_format			
		}
	},

	(dispatch, props) => ({
		populateData: () => {
			return dispatch(ReadingActions.batchFetchBook(
				{ id: props.textID, userID: (CurrentUser.get() || {}).id }
			))
		}
	})
)
class BookDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	missingBookCover() {
		var book = this.props.book || {};
		return book.cover_url == null || book.cover_url.includes("nophoto");
	}

	coverWidth() {
		return this.props.coverWidth || 98;
	}

	showCover() {
		return this.props.showCover || (
			this.props.contingentShowCover && !this.missingBookCover()
		);
	}

	renderCover() {
		var { book, platform } = this.props;
		var coverStyle = {
			width: this.coverWidth(), height: "auto"
		};

		if (book.url) {
			var urlCoverWidth = this.coverWidth() * 0.75;

			if (this.props.hideTitleIfCover) {
				return (
					<div className="urlCover text-center" style={{ minHeight: urlCoverWidth }}>
						<div className="text smallText">
							{ book.title }
						</div>
					</div>
				);
			} else if (platform && platform.img_url) {
				return (
					<div className="text-center platformCover">
						<img src={ platform.img_url } style={ coverStyle } />
					</div>
				);
			} else if (platform) {
				return (
					<div className="urlCover cursive text-center" style={{ minHeight: urlCoverWidth }}>
						<div className="text">
							{ platform.name }
						</div>
					</div>
				);
			} else {
				return (
					<div className="text-center platformCover">
						<img src={ require("reading/url-placeholder.png") } style={ coverStyle } />
					</div>
				);
			}
		} else { 
			if (this.missingBookCover()) {
				var bookColors = ["red", "blue", "gold", "green", "orange", "purple"]
				var bookNumber = $wr.psuedoRandom("seed", bookColors.length)
				var coverUrl = require("reading/book-covers/book-" + bookNumber+ ".png");
			} else {
				var coverUrl = book.cover_url;
			}

			return (
				<div>
					<img className="cover" src={ coverUrl } style={ coverStyle } />
				</div>
			);
		}
	}

	renderAbout() {
		var book = this.props.book;

		if (this.props.showAuthor && (book.author || book.author_full_name)) {
			var author = (
				<span className="author">{ book.author || book.author_full_name }</span>
			);
		}

		if (this.props.showURL && book.url) {
			var booksURL = (
				<a className="bookURL" href={ book.url } target="_blank">
					{ book.url }
				</a>
			);
		}

		if (book.url) {
			if (this.props.hideTitleIfCover) {

			} else {
				if (this.props.linkURL) {
					var urlLink = (
						<a className="linkURL" href={ book.url } target="_blank">
							<Glyphicon icon="new-window" />
						</a>
					)
				}

				var title = (
					<span className="title titleURL">
						{ book.title }
						{ urlLink }
					</span>
				);
			}

		} else {
			if (this.missingBookCover() || !this.props.hideTitleIfCover) {
				var title = (
					<span className="title">
						{ book.title }
					</span>
				);
			}
		}

		if (CurrentUser.isAdmin()) {
			var tooltipCopyType = ReadingLevelIcon.TEACHER_VIEW;
		} else {
			var tooltipCopyType = ReadingLevelIcon.STUDENT_VIEW;
		}

		if (book.lexile_score && this.props.showReadingLevel) {
			if (this.props.studentReadingLevel) {
				var studentReadingLevel = this.props.studentReadingLevel;
			} else {
				var studentReadingLevel = CurrentUser.get().current_reading_level;
			}
			var readingLevelDisplay = (
				<ReadingLevelIcon studentReadingLevel={ studentReadingLevel } 
					textReadingLevel={ book.lexile_score }  showImageOnly={ this.props.showImageOnly }
					tooltipCopyType={ tooltipCopyType } />
			)
		}

		if (this.props.showLibraryTags) {
			var libraryTagItems = [];

			if (book.text_variety) {
				libraryTagItems.push(
					<span className="badge libraryTag" key="text-variety">
						{ TextTypes.Varieties.getName(book.text_variety) }
					</span>
				)
			}

			if (book.lexile_score) {
				libraryTagItems.push(
					<span className="badge libraryTag" key="lexile">
						{ ReadingLevelFormat.getScoreForFormat(book.lexile_score, this.props.readingLevelFormat) }
					</span>
				)
			}

			if (book.ages) {
				book.ages.forEach((age) => {
					libraryTagItems.push(
						<span className="badge libraryTag" key={ "age-" + age }>
							{ age }
						</span>
					)
				})
			}


			if (book.topics) {
				book.topics.forEach((topic) => {
					libraryTagItems.push(
						<span className="badge libraryTag" key={ "topic-" + topic }>
							{ topic }
						</span>
					)
				})
			}

			var libraryTags = (
				<div>{ libraryTagItems } </div>
			)
		}

		return (
			<span className="about">
				{ title }
				{ author }
				{ booksURL }
				{ libraryTags }
				{ this.props.children }
				{ readingLevelDisplay }
			</span>
		);
	}

	render() {
		var book = this.props.book;

		if (!book) {
			// Loading state
			if (this.showCover()) {
				var loadingContent = <Spinner placeholder />
			} else {
				var loadingContent = "...";
			}

			return (
				<div className="bookDisplay">{ loadingContent }</div>
			);
		}

		var aboutStyle = {};
		var aboutClassName = "aboutWrap";

		if (this.showCover()) {
			aboutStyle.paddingLeft = this.coverWidth() + 15;
			// 15 is the gap between "about" and the cover

			var coverStyle = {
				display: "inline-block",
				width: this.coverWidth(),
				height: "auto",
				marginRight: (-1 * this.coverWidth())
			};
			var cover = (
				<div className="coverWrap" style={ coverStyle }>
					{ this.renderCover() }
				</div>
			);
		} else {
			aboutClassName += " withoutCover";
		}

		var about = this.renderAbout();

		var bookClassName = "bookDisplay";
		if (this.props.onClick) {
			bookClassName += " clickableElement";
		}

		if (this.props.inline) {
			bookClassName += " inlineBook";
		}

		return (
			<div className={ bookClassName } onClick={ this.props.onClick }>
				{ cover }
				<div className={ aboutClassName } style={ aboutStyle }>
					{ about }
				</div>
			</div>
		);
	}

	componentDidMount() {
		if (!(this.props.book && this.props.book.title) && (this.props.loadBook === undefined || this.props.loadBook)) {
			this.props.populateData();
		}
	}
}

var QUIZZES_VIEW = "quizzes";
var ANSWERS_VIEW = "answers";

BookDisplay.WrappedComponent.propTypes = StrictPropTypes({
	// ID of the book to be displayed
	textID: PropTypes.string,

	// If set, renders the book's cover before the title
	showCover: PropTypes.bool,

	// If set, renders the book's cover ONLY IF there is a unique book cover image
	contingentShowCover: PropTypes.bool,

	// If set, renders the book's author after the title
	showAuthor: PropTypes.bool,

	// If set, renders the book's URL (limited to 1 line) after the title
	showURL: PropTypes.bool,

	linkURL: PropTypes.bool,

	// If set, renders tags for the books text variety, age, topics, etc.
	showLibraryTags: PropTypes.bool,

	showReadingLevelIcon: PropTypes.bool,

	// If set, renders the title only if the book cover is missing
	hideTitleIfCover: PropTypes.bool,

	// Width of the cover (default is 98)
	coverWidth: PropTypes.number,

	readingLevelFormat: PropTypes.string,

	inline: PropTypes.bool,

	children: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.array
	]),

	onClick: PropTypes.func,

	loadBook: PropTypes.bool,

	// From @connect
	// Which are present is determined by the other props
	book: PropTypes.object,
	platform: PropTypes.object,
	populateData: PropTypes.func.isRequired,

	studentReadingLevel: PropTypes.number,
	showExclusionNote: PropTypes.bool,
	showReadingLevel: PropTypes.bool

});

module.exports = BookDisplay


// WEBPACK FOOTER //
// ./modules/components/reading/books/BookDisplay.js